import React from 'react'
import PropTypes from 'prop-types'
import { SmartImage } from 'shared/UI/SmartImage'
import { getItemTypeConfig } from 'LiveBoard/components/shared/ItemType'
import { ITEM } from 'LiveBoard/components/shared/SideBySide/constants'

import './style.css.scss'

const Item = (props) => {

  const item = props.data
  const itemTypeConfig = getItemTypeConfig(item)
  const handleClick = () => props.onClick(ITEM, {
    showNewTab: item.open_in_new_tab,
    item: item
  })

  return (
    <span className="side-by-side-item-tile" onClick={handleClick} tabIndex="0">
      { itemTypeConfig.isVideo && <span className="icon-play-button" /> }
      <div className="item-tile-image-wrapper">
        <SmartImage config={item.image} />
      </div>
    </span>
  )
}

Item.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
}

export default Item
